// english

export default {
  deviceModel_title: 'Device Model Manage',
  deviceMode_base_title: 'Base Information',
  deviceMode_config_title: 'Config List',
  deviceMode_params_title: 'Params List',
  deviceMode_control_title: 'Control List',
  deviceMode_config_add_title: 'Add New Config Item',
  deviceMode_config_edit_title: 'Edit Config Item',
  deviceMode_config_fork_title: 'Fork New Config Item',

  deviceMode_params_add_title: 'Add New Params Item',
  deviceMode_params_edit_title: 'Edit Params Item',
  deviceMode_params_fork_title: 'Fork New Params Item',

  deviceMode_control_add_title: 'Add New Control Item',
  deviceMode_control_edit_title: 'Edit Control Item',
  deviceMode_control_fork_title: 'Fork New Control Item',

  deviceMode_model_fork_title: 'Fork New Model',
  deviceMode_model_edit_title: 'Edit Model',
  deviceMode_model_add_title: 'Add New Model',

  // conifrm
  deviceModel_confirm_delete_title: 'Do you confirm to delete this Model?',
  deviceModel_confirm_delete_content: 'Model Name: {name}',

  deviceModel_confirm_delete_item_title: 'Do you confirm to delete this item?',
  deviceModel_confirm_delete_some_item_title: 'Do you confirm to delete these items?',

  // table
  deviceModel_table_name: 'Model',
  deviceModel_table_web: 'WEB',
  deviceModel_table_ssh: 'SSH',
  deviceModel_table_web_ssh: 'WEB/SSH',
  deviceModel_table_group_name: 'Group Name',
  deviceModel_table_params: 'Params',
  deviceModel_table_param1: 'Param #1',
  deviceModel_table_param2: 'Param #2',
  deviceModel_table_filter_group: 'Filter By Group',
  deviceModel_table_rw_level: 'R/W Level',
  deviceModel_table_batch_support: 'Is Batch Support',
  deviceModel_table_data_type: 'Data Type',
  deviceModel_table_data_range: 'Data Range',

  // form
  deviceModel_form_model_name: 'Model Name',
  deviceModel_form_model_name_placeholder: 'Please input name',
  deviceModel_form_parent_model: 'Parent Mode',
  deviceModel_form_parent_model_placeholder: 'Please select a parent model',
  deviceModel_form_support_ssh: 'Support SSH',
  deviceModel_form_support_web: 'Support WEB',
  deviceModel_form_model_image: 'Model Images',
  deviceModel_form_avatar: 'Parent Mode',
  deviceModel_form_avatar_placeholder: 'Please select a parent model',

  deviceModel_form_model: 'Device Model',
  deviceModel_form_model_all: 'All Models',
  deviceModel_form_config_group: 'Config Group',
  deviceModel_form_config_group_placeholder: 'Please select a config group',
  deviceModel_form_config_item: 'Config Item',
  deviceModel_form_config_item_placeholder: 'Please select a config item',
  deviceModel_form_protocol: 'Protocol Key',
  deviceModel_form_protocol_placeholder: 'Please input protocol key',
  deviceModel_form_display_priority: 'Display Priority',
  deviceModel_form_display_priority_placeholder: 'Please input display priority',
  deviceModel_form_data_read_level: 'Read Level',
  deviceModel_form_data_read_level_placeholder: 'Please input read level',
  deviceModel_form_data_write_level: 'Write Level',
  deviceModel_form_data_write_level_placeholder: 'Please input write level',
  deviceModel_form_data_write_tips: 'Control Level must be greater than',
  deviceModel_form_input: 'Input',
  deviceModel_form_batch_support: 'Batch Support',

  deviceModel_form_control_name: 'Control Name',
  deviceModel_form_control_name_placeholder: 'Please input control name',
  deviceModel_form_control_type: 'Control Type',
  deviceModel_form_control_type_help:
    'The control command codes cannot be repeated in the same device model. The existing commands are: 1 - soft reset, 2 - hard reset, 3 - disable system, 4 - disable connector (connector Id is specified by the param field), 5 - ftp software upgrade (url is provided by param), 6 - ftp log upload (url is provided by param), 7 - vpn start, 8 - vpn stop, 9 - restart CCU (Pilot monitoring), 10 - Update PLC FW thru FTP',
  deviceModel_form_control_type_placeholder: 'Please input controy type',
  deviceModel_form_control_type_error: 'has already been used, please use a different name.',
  deviceModel_form_control_level: 'Control Level',
  deviceModel_form_control_level_placeholder: 'Please input control level',
  deviceModel_form_control_param1: 'Param 1 name',
  deviceModel_form_control_param1_placeholder: 'Please input param 1 name',
  deviceModel_form_control_param2: 'Param 2 name',
  deviceModel_form_control_param2_placeholder: 'Please input param 2 name',
  deviceModel_form_control_param_help: 'Optional',

  deviceModel_alias_title: 'Device Model Alias',
  deviceModel_alias_description:
    'Note: After adding a device model alias, all places where the device model name is displayed on this platform will display the device model alias you modified, and you can also restore it by deleting the alias',
  deviceModel_no_alias: 'No Alias',
  // 原始名
  deviceModel_original_name: 'Original Name',
  // 别名
  deviceModel_alias_name: 'Alias Name',
  deviceModel_alias_name_placeholder: 'Please input alias name',
};
